// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__JFyV9","headerContainer":"styles_headerContainer__uPlH7","headerTitleContainer":"styles_headerTitleContainer__RJtQP"};